/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseOfString } from '../../models/api-response-of-string';
import { PatientArchiveSettings } from '../../models/patient-archive-settings';

export interface PatientArchivePost$Params {
      body: PatientArchiveSettings
}

export function patientArchivePost(http: HttpClient, rootUrl: string, params: PatientArchivePost$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOfString>> {
  const rb = new RequestBuilder(rootUrl, patientArchivePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseOfString>;
    })
  );
}

patientArchivePost.PATH = '/api/PatientArchive/patientarchive/upsert';
